<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<block-ui [template]="blockTemplate">
  <!-- <block-ui > -->
    <div [ngClass]="selectedTheme">
    <mat-sidenav-container fullscreen class="Site">
      <mat-sidenav #sidenav disableClose position="end"> <aside-container></aside-container> </mat-sidenav>

      <mat-sidenav-content>
        <main class="main">
          <app-header (toggleMenuEvent)="toggleMainMenu()"></app-header>
          <section class="content Site-content">
            <mat-sidenav-container class="nav-container" fullscreen>
              <mat-sidenav #drawer mode="side" [opened]="showMenu && mainMenuService.menuVisible" role="navigation" class="side-menu" color="primary">
                <side-menu></side-menu>
              </mat-sidenav>
              <div class="content-main">
                <router-outlet></router-outlet>
              </div>
            </mat-sidenav-container>
          </section>
        </main>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</block-ui>

<!-- <ng-template #blockTemplate>
  <div class="block-ui-template">
    <div>
      <b>This is blocked...</b>
    </div>
    <div>
      <i>Pleae wait..</i>
      <a href="#">Reload</a>
    </div>
  </div>
</ng-template> -->
